import { UserModel } from "./UserModel";

export const UserSerializer = () => {
  const userModel = UserModel();

  const createUserSerializer = (body) => {
    return userModel.createUserModel(body);
  };

  const getCurrentUserInfoDeserializer = (response) => {
    //TODO: Optimized way?
    const result = {
      ...response,
      // fullName: response.fullname,
      // licenseNumber: response.license_number,
      // phoneNumber: response.phone_number,
      // postalCode: response.postal_code,
      // stateProvince: response.state_or_province,
    };
    // delete result.fullname;
    // delete result.license_number;
    // delete result.phone_number;
    // delete result.postal_code;
    // delete result.state_or_province;

    return result;
  };

  const updateCurrentUserInfoSerializer = (body) => {
    const result = {
      ...body,
      fullname: body.fullname,
      license_number: body.license_number,
      phone_number: body.phone_number,
      postal_code: body.postal_code,
      state_or_province: body.state_or_province,
    };
    // delete result.fullName;
    // delete result.licenseNumber;
    // delete result.phoneNumber;
    // delete result.postalCode;
    // delete result.stateProvince;

    return result;
  };

  const updatePassword = (body) => {
    return {
      old_password: body.oldPassword,
      new_password: body.newPassword,
    };
  };

  return Object.freeze({
    createUserSerializer,
    getCurrentUserInfoDeserializer,
    updateCurrentUserInfoSerializer,
    updatePassword,
  });
};
